var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('img',{staticClass:"text",attrs:{"src":require("../images/share_bottom_text@3x.png"),"alt":"网易蜗牛读书"}}),_c('div',{staticClass:"download",on:{"click":_vm.downloadClickHandler}},[_vm._v("下载网易蜗牛读书")])])}
var staticRenderFns = []

export { render, staticRenderFns }